import { createGlobalStore } from "@wss/store";
export const ModalTypes = {
  PLUS: "plus",
  INELIGIBLE: "ineligible",
  CLOSED: null
} as const;
type ModalType = typeof ModalTypes[keyof typeof ModalTypes];
interface PlusSubscriptionModalState {
  modalType: ModalType;
  setModalOpen: (type: ModalType) => void;
}
const PlusSubscriptionModalStore = createGlobalStore<PlusSubscriptionModalState>(set => ({
  modalType: ModalTypes.CLOSED,
  setModalOpen: type => set({
    modalType: type
  })
}));
export default PlusSubscriptionModalStore;